import { Props as IntlProps } from 'react-intl/src/components/message'

export { LegacyGrid } from './legacy-grid'
export { TableRow } from './legacy-grid-table-row'
export { TableRows } from './legacy-grid-table-rows'
export { ParentRow } from './legacy-grid-parent-row'
export { Cell } from './legacy-grid-cell'
export { GenericSorter } from './generic-sorter'
export { GenericFilterer } from './generic-filterer'
export {
  ControlsNoData,
  ControlsWithData,
  QuickFiltersControls,
  quickFiltersDropdownTestId
} from './controls'
export { Description } from './controls'
export type { LegacyQuickFilter } from './controls'
export { LegacyGridSpinner } from './legacy-grid-spinner'
export { LegacyGridSortAction } from './legacy-grid-sort-action'

export interface ParentRowData {
  readonly id: string
  readonly name: string
}

export interface BaseRowData {
  readonly id: string
  readonly parent?: ParentRowData
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface SortConfig<TLegacyRowData> {
  readonly field: keyof TLegacyRowData
  readonly order: SortOrder
  readonly getValue?: (data: TLegacyRowData) => any
  readonly sortAsc?: (a: TLegacyRowData, b: TLegacyRowData) => number
}

interface CellStyles {
  readonly maxWidth?: string
  readonly width?: string
  readonly padding?: string
  readonly verticalAlign?: string
}

interface HeadingStyles {
  readonly paddingLeft: string
}

export interface LegacyGridColumn<TLegacyRowData> {
  readonly styles?: CellStyles
  readonly heading?: IntlProps
  readonly headingStyles?: HeadingStyles
  readonly sorting?: {
    readonly field: keyof TLegacyRowData
    readonly getValue?: (data: TLegacyRowData) => any
    readonly sortAsc?: (a: TLegacyRowData, b: TLegacyRowData) => number
  }
  readonly horizontalCenter?: boolean
  readonly CellContent: (props: {
    readonly rowData: TLegacyRowData
    readonly hasParent?: boolean
  }) => JSX.Element
}
